import { render, staticRenderFns } from "./systemParcelViewClientsPage.vue?vue&type=template&id=1782ba0c&scoped=true&"
import script from "./systemParcelViewClientsPage.vue?vue&type=script&lang=js&"
export * from "./systemParcelViewClientsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1782ba0c",
  null
  
)

export default component.exports